import MovMensalProvider, { MovMensalContext } from 'pages/Supplier/MovMensal/context/MovMensalContext/MovMensalContext'
import { useContextSelector } from 'use-context-selector'

const useMovement = () => {
  const setSelectedMovement = useContextSelector(
    MovMensalContext,
    (state) => state.setSelectedMovement
  )
  const selectedMovement = useContextSelector(
    MovMensalContext,
    (state) => state.selectedMovement
  )
  const parametrization = useContextSelector(
    MovMensalContext,
    (state) => state.parametrization
  )
  const setParametrization = useContextSelector(
    MovMensalContext,
    (state) => state.setParametrization
  )
  const movState = useContextSelector(
    MovMensalContext,
    (state) => state.movState
  )

  const setMovState = useContextSelector(
    MovMensalContext,
    (state) => state.setMovState
  )
  const handleError = useContextSelector(
    MovMensalContext,
    (state) => state.handleError
  )

  const handleChangeMobilizacao = useContextSelector(
    MovMensalContext,
    (state) => state.handleChangeMobilizacao
  )

  const dataAtuacaoInvalida = useContextSelector(
    MovMensalContext,
    (state) => state.dataAtuacaoInvalida
  )

  const setDataAtuacaoInvalida = useContextSelector(
    MovMensalContext,
    (state) => state.setDataAtuacaoInvalida
  )

  const handleBlock = useContextSelector(
    MovMensalContext,
    (state) => state.handleBlock
  )

  const blockIndividualVision = useContextSelector(
    MovMensalContext,
    (state) => state.blockIndividualVision
  )

  const blockTotalVision = useContextSelector(
    MovMensalContext,
    (state) => state.blockTotalVision
  )

  const setIsAnalista = useContextSelector(
    MovMensalContext,
    (state) => state.setIsAnalista
  )
  const setIsContraparte = useContextSelector(
    MovMensalContext,
    (state) => state.setIsContraparte
  )
  const isAnalista = useContextSelector(
    MovMensalContext,
    (state) => state.isAnalista
  )
  const isContraparte = useContextSelector(
    MovMensalContext,
    (state) => state.isContraparte
  )

  const errorsTotalVision = useContextSelector(
    MovMensalContext,
    (state) => state.errorsTotalVision
  )

  const setErrorsTotalVision = useContextSelector(
    MovMensalContext,
    (state) => state.setErrorsTotalVision
  )

  const blockVerifyIndividual = useContextSelector(
    MovMensalContext,
    (state) => state.blockVerifyIndividual
  )

  const setBlockVerifyIndividual = useContextSelector(
    MovMensalContext,
    (state) => state.setBlockVerifyIndividual
  )

  const resetContext = useContextSelector(
    MovMensalContext,
    (state) => state.resetContext
  )

  const isSomenteCompartilhado = useContextSelector(
    MovMensalContext,
    (state) => state.movState.flStatusMobilizacao === '2'
  )

  const isComMobilizacao = useContextSelector(
    MovMensalContext,
    (state) => state.movState.flStatusMobilizacao === '1'
  )

  const isSemMobilizacao = useContextSelector(
    MovMensalContext,
    (state) => state.movState.flStatusMobilizacao === '0'
  )

  const cdContratoCompartilhado = useContextSelector(
    MovMensalContext,
    (state) => state.movState.cdContratoCompartilhado
  )

  // EXEMPLO - 02/2022 vira 202202
  let competenciaSelecionada

  if (selectedMovement?.mesAno.length > 6)
    competenciaSelecionada =
      selectedMovement?.mesAno?.split('/')[1] +
      selectedMovement?.mesAno?.split('/')[0]
  else competenciaSelecionada = selectedMovement?.mesAno

  return {
    cdContratoCompartilhado,
    blockIndividualVision,
    blockTotalVision,
    blockVerifyIndividual,
    competenciaSelecionada,
    dataAtuacaoInvalida,
    errorsTotalVision,
    handleBlock,
    handleChangeMobilizacao,
    handleError,
    isAnalista,
    isComMobilizacao,
    isContraparte,
    isSemMobilizacao,
    isSomenteCompartilhado,
    movState,
    parametrization,
    resetContext,
    selectedMovement,
    setBlockVerifyIndividual,
    setDataAtuacaoInvalida,
    setErrorsTotalVision,
    setIsAnalista,
    setIsContraparte,
    setMovState,
    setParametrization,
    setSelectedMovement,
  }
}

export default useMovement
